<template>
    <v-row>
        <!-- TITLE -->
        <v-col cols="12" class="title-section" v-if="!noTitle">
            {{ $t('routines.create_new') }}
        </v-col>
        <!-- NAME -->
        <v-col cols="12">
            <kimsa-text-field
                :label="$t('routines.give_a_name')"
                :placeholder="$t('routines.give_routine_name_placeholder')"
                :value="name" @change="name = $event"
                bolder-label outlined dense no-elevation
            />
        </v-col>
        <!-- IMG -->
        <v-col cols="12">
            <div class="label mb-1">
                {{ $t('common.select_an_image') }}
            </div>
            <file-uploader
                ref="imgUploader"
                mime-types="image/*"
                @success="onImgUploaded"
                relative-path="images/routines"
                :limit-size="2"
                @change="onChangeImg">
                <template slot="button">
                    <div class="img-container">
                        <div v-if="imgUrl" class="img-preview" :style="`background-image: url(${imgUrl})`">
                            <div class="img-name" @click.stop="clearImg">
                                {{ imgName }}
                                <v-icon x-small color="error">$close</v-icon>
                            </div>
                        </div>
                        <div class="img-content" v-else>
                            <v-icon size="28">$upload_image</v-icon>
                            <div class="load-image-title">
                                {{ $t('common.load_image') }}
                            </div>
                            <div class="load-image-subtitle">
                                {{ $t('common.load_image_max_size') }} <span
                                class="load-image-subtitle bolder">2MB</span>
                            </div>
                        </div>
                    </div>
                </template>
            </file-uploader>
        </v-col>
        <!-- OBJECTIVE -->
        <v-col cols="12">
            <chip-selector
                :label="$t('common.select_an_objective')"
                :items="objectives"
                :value="objective"
                @change="objective = $event"
            />
        </v-col>
    </v-row>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import FileUploader from "@/components/common/FileUploader";
import ChipSelector from "@/components/common/inputs/ChipSelector";
import {mapActions, mapState} from "vuex";

export default {
    props: {
        defaults: {
            type: Object,
            default: null
        },
        noTitle: {
            type: Boolean,
            default: false,
        }
    },
    components: {ChipSelector, KimsaTextField, FileUploader},
    data() {
        return {
            name: '',
            imgName: '',
            imgUrl: '',
            uploadedImg: null,
            objective: '',
        }
    },
    computed: {
        ...mapState(['config']),
        objectives(vm = this) {
            return vm.config?.routineCategories?.map(obj => ({name: obj.name, value: obj.name})) || []
        },
        form(vm = this) {
            return {
                name: vm.name,
                imgName: vm.imgName,
                imgUrl: vm.imgUrl,
                objective: vm.objective,
            }
        },
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.setDefaults()
    },
    methods: {
        ...mapActions(['bindConfig']),
        setDefaults() {
            const vm = this
            if (!vm.defaults) return;
            vm.name = vm.defaults.name || ''
            vm.imgUrl = vm.defaults.img || ''
            vm.objective = vm.defaults.objective || ''
        },
        onChangeImg({name, url}) {
            const vm = this
            vm.imgName = name
            vm.imgUrl = url
        },
        async onImgUploaded({downloadURL, savePath}) {
            const vm = this
            vm.uploadedImg = {
                url: downloadURL,
                savePath: savePath
            }
        },
        clearImg() {
            const vm = this
            vm.imgName = ''
            vm.imgUrl = ''
            vm.uploadedImg = null
            vm.$refs.imgUploader.reset()
        },
        async upload() {
            const vm = this
            if (vm.imgUrl.includes('blob:')) await vm.$refs.imgUploader.upload()
        }
    },
    watch: {
        defaults() {
            this.setDefaults()
        },
        name() {
            this.$emit('change', this.form)
        },
        objective() {
            this.$emit('change', this.form)
        },
        uploadedImg(val) {
            this.$emit('img', val)
        },
    },
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
    text-align: center;
    margin-top: 20px;
}

.label {
    font-size: 15px;
    color: #333333;
    font-weight: 700;
}

.img-container {
    background: #FEFEFE;
    border: 1px solid #999999;
    border-radius: 4px;
    width: 223px;
    height: 100px;
    position: relative;
    cursor: pointer;
}

.img-content {
    position: absolute;
    text-align: center;
    left: 0;
    right: 0;
    top: 16%;
}

.load-image-title {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #797979;
}

.load-image-subtitle {
    font-weight: 275;
    font-size: 10px;
    line-height: 14px;
    color: rgba(121, 121, 121, 0.7);
}

.img-preview {
    height: 100%;
    background-color: rgba(115, 115, 115, .05);
    background-position: center;
    background-size: contain;
}

.img-name {
    font-weight: 275;
    font-size: 10px;
    line-height: 14px;
    color: #e0e0e0;
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: rgba(115, 115, 115, .75);
    padding: 2px 4px;
    border-radius: 4px;
    max-width: 91%;
    text-align: right;
    cursor: pointer;
}

</style>